"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const User = ({ fill = "currentcolor", size = 16, }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true, fill: fill },
    react_1.default.createElement("ellipse", { cx: "8", cy: "7.5", rx: "4", ry: "5" }),
    react_1.default.createElement("path", { d: "M16 16H0c0-1.4 0-3.1 1.3-3.4 4.8-1.4 8.6-1.4 13.3 0 1.4.3 1.4 2 1.4 3.4z" })));
exports.User = User;
//# sourceMappingURL=User.js.map